import React, { FC, useContext } from "react";

import { IBoxDashboard } from "../../../../state";
import { Context } from "../../../../store/teacher";

import styles from "./SubmitterList.module.scss";

type Props = {
  calling: boolean;
  box: IBoxDashboard;
};

const SubmitterList: FC<Props> = ({ calling, box }) => {
  const { contextState } = useContext(Context);

  return (
    <div className={styles.gearboxStudents}>
      <div>提出者一覧</div>
      <p>
        <span>名前</span>
        <span>総Stock数 {box ? box.realizations_count : 0}</span>
      </p>
      {!contextState.gearboxStudents.length && calling ? (
        <div className={styles.loading}>読み込み中</div>
      ) : contextState.gearboxStudents.length ? (
        <ul>
          {contextState.gearboxStudents.map(student => (
            <li key={student.id}>
              <span>{student.full_name}</span>
              <span>{student.realizations_count ?? "-"}</span>
            </li>
          ))}
          {!!contextState.realizations_count_of_left_students && (
            <li>
              <span>その他</span>
              <span>{contextState.realizations_count_of_left_students}</span>
            </li>
          )}
        </ul>
      ) : (
        <div className={styles.emptyData}>空のデータ。</div>
      )}
    </div>
  );
};

export default SubmitterList;
